import { Tooltip } from "@ad/anq-ui";
import { TooltipProps } from "@ad/anq-ui/lib/tooltip";
import classNames from "classnames";
import React, {
  HTMLAttributes,
  useRef,
  useState,
  PropsWithChildren,
} from "react";

interface Props extends PropsWithChildren<HTMLAttributes<HTMLDivElement>> {
  tooltipProps?: Omit<TooltipProps, "children" | "title">;
}

/**
 * 单行文本超出展示tooltip
 * TODO: 考虑rocket-ui的typography
 */
const EllipsisText = ({
  children,
  className,
  tooltipProps = {},
  ...restProps
}: Props) => {
  const [showEllipsis, setShowEllipsis] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleShowEllipsis = () => {
    if (wrapperRef.current && contentRef.current) {
      setShowEllipsis(
        contentRef.current.clientHeight > wrapperRef.current.clientHeight ||
          contentRef.current.clientWidth > wrapperRef.current.clientWidth
      );
    }
  };

  const content = (
    <div
      className={classNames(
        "relative w-full overflow-hidden text-ellipsis whitespace-nowrap",
        className
      )}
      ref={(dom) => {
        wrapperRef.current = dom;
        handleShowEllipsis();
      }}
      {...restProps}
    >
      {children}
      <div
        className="invisible absolute whitespace-nowrap"
        ref={(dom) => {
          contentRef.current = dom;
          handleShowEllipsis();
        }}
      >
        {children}
      </div>
    </div>
  );

  return showEllipsis ? (
    <Tooltip title={children} {...tooltipProps}>
      {content}
    </Tooltip>
  ) : (
    content
  );
};

export default EllipsisText;
